module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "tx-page-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("relation_title")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "tx-page-subtitle"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("relation_subtitle")) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid list-style"
  }, _vm._l((_vm.list), function(news) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "30px 0 0 0"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 col-sm-4",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('a', {
      attrs: {
        "href": news.url,
        "target": "_blank"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": news.image
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-8 info-style"
    }, [_c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "0"
      }
    }, [_c('a', {
      staticStyle: {
        "font-size": "18px",
        "color": "#4A4A4A!important",
        "text-decoration": "none"
      },
      attrs: {
        "href": news.url,
        "target": "_blank"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.nls(news.title)) + "\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "10px 0 10px 0",
        "font-size": "16px",
        "color": "#9B9B9B"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.nls(news.brief)) + "   [ " + _vm._s(news.date) + " ]\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12",
      staticStyle: {
        "padding": "0",
        "font-size": "16px"
      }
    }, [_c('a', {
      attrs: {
        "href": news.url,
        "target": "_blank"
      }
    }, [_vm._v("\n                            " + _vm._s(_vm.$t("relation_more")) + "\n                        ")])])])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49ca4170"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public_relation.vue
// module id = 105
// module chunks = 9